import React, { ChangeEvent, ReactElement, useEffect } from 'react';
import { DocCompType } from '../../redux/reducers/companyDetailsReducer';
import { Box, Grid2, IconButton, TextField } from '@mui/material';
import { useAppDispatch } from '../../hooks/hooks';
import {
    removeDocumentCompanyDetail,
    updateLabelForDocumentCompanyDetail,
    updateValueForDocumentCompanyDetail,
} from '../../redux/actions/companyDetailsActions';
import DeleteIcon from '@mui/icons-material/Delete';

type DocumentCompanyDataTemplateProps = {
    docData: DocCompType | undefined;
};

export default function DocumentCompanyDataTemplate(props: DocumentCompanyDataTemplateProps): ReactElement {
    const { docData } = props;

    const dispatch = useAppDispatch();

    const handleChangeLabel = (e: ChangeEvent<HTMLInputElement>) => {
        const val = e.target.value;

        dispatch(updateLabelForDocumentCompanyDetail({ index: docData?.index ?? 0, label: val }));
    };

    const handleChangeValue = (e: ChangeEvent<HTMLInputElement>) => {
        const val = e.target.value;

        dispatch(updateValueForDocumentCompanyDetail({ index: docData?.index ?? 0, value: val }));
    };

    const handleRemoveCompanyDetail = () => {
        dispatch(removeDocumentCompanyDetail(docData?.index ?? 0));
    };

    return !docData ? (
        <></>
    ) : (
        <Grid2 container spacing={2}>
            <Grid2 size={{ xs: 12, md: 5 }}>
                <TextField
                    error={!!docData?.label && docData?.label !== '' ? false : true}
                    required
                    fullWidth
                    name="label"
                    label="Labela"
                    value={!!docData?.label ? docData?.label : ''}
                    variant="outlined"
                    onChange={handleChangeLabel}
                />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 5 }}>
                <TextField
                    error={!!docData?.value && docData?.value !== '' ? false : true}
                    required
                    fullWidth
                    name="value"
                    label="Vrednost"
                    value={!!docData?.value ? docData?.value : ''}
                    variant="outlined"
                    onChange={handleChangeValue}
                />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 2 }} sx={{ textAlign: 'center' }}>
                <IconButton color="error" onClick={handleRemoveCompanyDetail}>
                    <DeleteIcon color="error" />
                </IconButton>
            </Grid2>
        </Grid2>
    );
}
